import { render, staticRenderFns } from "./phoneUpload.vue?vue&type=template&id=4de5f841&scoped=true&"
import script from "./phoneUpload.vue?vue&type=script&lang=js&"
export * from "./phoneUpload.vue?vue&type=script&lang=js&"
import style0 from "./phoneUpload.vue?vue&type=style&index=0&id=4de5f841&scoped=true&lang=css&"
import style1 from "./phoneUpload.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5f841",
  null
  
)

export default component.exports